import Switzerland from './Switzerland'

export default Switzerland
